// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__WCkz9","actions":"GroupTable_actions__13X2L","deleteModalFooter":"GroupTable_deleteModalFooter__25fwS"};